var map = {
	"./another_crabs_treasure.png": 3928,
	"./black_myth_wukong.png": 3037,
	"./celeste.png": 3938,
	"./cs2.png": 9275,
	"./cyber_punk2077.png": 4453,
	"./dark_soul3.png": 6582,
	"./death_stranding.jpg": 4960,
	"./deep_rock_galactic.png": 6970,
	"./edith_finch.png": 5760,
	"./enter_the_gungeon.png": 7137,
	"./final_fantasy_vii.png": 8733,
	"./forza_horizon4.png": 3729,
	"./ghost_of_tsushima.png": 4721,
	"./ghost_trick.png": 7466,
	"./god_of_war.png": 8066,
	"./guardians_of_the_galaxy.png": 3472,
	"./katamari.png": 7379,
	"./moncage.png": 7185,
	"./monster_hunter_world.png": 3517,
	"./sea_of_thieves.png": 5497,
	"./sifu.png": 1752,
	"./spiritfarer.png": 5344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2345;